<template>
  <div>
    <div>
      <breadcrumb :breadcrumb_link="option_breadcrumb" />
    </div>

    <div class="header">
      <h1 class="overlay">OPTION PROGRAM</h1>
      <!--      <img src="@/assets/images/Podohotel/hotspring_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>

    <div class="container">
      <div class="row d-flex justify-content-center">
        <!--        <div>-->
        <!--          <img src="@/assets/images/pleisure/pleisure_headerimage.jpg" />-->
        <!--        </div>-->
        <div class="col-lg-12 rowSpace"></div>
        <div class="text-center col-lg-12 mainTitle">{{ $t('flower_title') }}</div>
        <div class="mainTitleLine">
          <hr />
        </div>
        <div class="col-lg-12 text-center mainIntro">{{ $t('flower_subtitle') }}</div>
        <div class="rowSpace"></div>
        <div class="col buttonArea">
          <button class="prev-button" @click="$router.go(-1)">{{ $t('prev_button') }}</button>
        </div>
        <div class="rowSpace"><hr /></div>
        <GallerySlideCarousels :slides="main_slides" :slide-count="4" :thumb-slide-width="45" />
      </div>
    </div>
    <div class="container subContainer">
      <div class="row d-flex justify-content-center">
        <div class="col-lg-12 mainInfo">
          <div class="subDetail" v-html="$t('flower_desc')"></div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('flower_program_title') }}</div>

          <table class="col-lg-12 table table-bordered subTable">
            <thead>
              <tr>
                <td style="width: 40%">{{ $t('flower_table_tr1_td1') }}</td>
                <td style="width: 30%">{{ $t('flower_table_tr1_td2') }}</td>
                <td style="width: 30%">{{ $t('flower_table_tr1_td3') }}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowspan="3">{{ $t('flower_table_tr2_td1') }}</td>
                <td>Inclusive</td>
                <td>{{ $t('flower_table_tr2_td3') }}</td>
              </tr>
              <tr>
                <td>Luxury</td>
                <td>{{ $t('flower_table_tr3_td2') }}</td>
              </tr>
              <tr>
                <td>Premium</td>
                <td>{{ $t('flower_table_tr4_td2') }}</td>
              </tr>
            </tbody>
          </table>
          <div class="etcDetail">{{ $t('flower_table_desc') }}</div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('flower_combi_title') }}</div>
          <ol>
            <li>{{ $t('flower_combi_desc1') }}</li>
            <li>{{ $t('flower_combi_desc2') }}</li>
            <li>{{ $t('flower_combi_desc3') }}</li>
            <li>{{ $t('flower_combi_desc4') }}</li>
            <li>{{ $t('flower_combi_desc5') }}</li>
            <li>{{ $t('flower_combi_desc6') }}</li>
          </ol>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('flower_reserve_title') }}</div>
          <ol>
            <li>{{ $t('flower_reserve_desc1') }}</li>
            <li>{{ $t('flower_reserve_desc2') }}</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import GallerySlideCarousels from '@/components/GallerySlideCarousels';

export default {
  name: 'Flowersetting',
  data() {
    return {
      isLang: 0,
      option_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'SPECIAL OFFERS',
        present: this.$t('breadcrumb'),
      },
      main_slides: [
        {image: require('@/assets/images/pleisure/option/flowersetting_01.jpg')},
        {image: require('@/assets/images/pleisure/option/flowersetting_02.jpg')},
        {image: require('@/assets/images/pleisure/option/flowersetting_03.jpg')},
        {image: require('@/assets/images/pleisure/option/flowersetting_04.jpg')},
      ],
    };
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }
      this.program_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'SPECIAL OFFERS',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  components: {Breadcrumb, GallerySlideCarousels},
};
</script>

<style scoped lang="scss">
td {
  vertical-align: middle;
}
li {
  list-style-type: square;
  font-size: 0.9rem;
}

.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}
.mainTitle {
  font-weight: 800;
  font-size: 2rem;
  letter-spacing: -0.1rem;
}
.mainTitleLine {
  width: 10%;
  > hr {
  }
}
.mainIntro {
  word-break: keep-all;
}
.buttonArea {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .resserve-button {
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: #524a3d;
    color: #fff;
  }
  .prev-button {
    justify-content: center;
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: white;
    color: #000;
    border: 1px solid black;
  }
}
.subContainer {
  width: 100%;
}
.mainInfo {
  padding: 1rem;
  width: 100%;
  height: 100%;
  > div {
    line-height: 1.5rem;
    font-size: 1rem;
  }
}
.serviceArea {
  padding: 1rem;
  > span {
    font-size: 0.8rem;
  }
}
.subTitle {
  font-weight: 600;
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}
.subDetail {
  font-size: 0.9rem;
  padding-left: 1rem;
  word-break: keep-all;
}
.etcDetail {
  font-size: 0.8rem;
  padding-left: 1rem;
  color: #616161;
}
.subTable {
  > thead {
    background-color: #eaeaea;

    > tr > td {
      width: 50%;
      text-align: center;
      font-weight: 600;
    }
  }
  > tbody {
    > tr > td {
      text-align: center;
      font-size: 0.9rem;
    }
  }
  margin-bottom: 0.5rem;
}

.rowSpace {
  width: 100%;
  height: 2rem;
  > hr {
  }
}

@media (min-width: 992px) {
  .headerimage {
    width: 100%;
    margin: 0;
    content: url('~@/assets/images/common/option_headerimage.jpg');
  }
  .web {
    display: block;
  }
  .mobile {
    display: none;
  }
  .tHeader {
    font-size: 1.1rem;
  }
  .tBody {
    font-size: 1rem;
  }
}
@media (max-width: 992px) {
  .headerimage {
  }
  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: bold;
    }
  }
  .headerimage {
    display: none;
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "옵션 프로그램",
    "flower_title": "플라워 세팅",
    "flower_subtitle": "특별한 날, 소중한 분을 위한 플라워 데코레이팅 서비스",
    "prev_button": "이전",
    "flower_desc": "특별한 날을 더욱 빛나게 해 드릴 플라워 데코레이팅 서비스입니다.<br/>원하시는 이벤트에 따른 맞춤형 서비스로 프러포즈, 기념일 등 소중한 분을 위한 멋진 선물을 준비해 보세요.",
    "flower_program_title": "운영 프로그램",
    "flower_table_tr1_td1": "프로그램",
    "flower_table_tr1_td2": "옵션",
    "flower_table_tr1_td3": "요금(2인 기준)",
    "flower_table_tr2_td1": "플라워 데코레이팅 서비스",
    "flower_table_tr2_td2": "Inclusive",
    "flower_table_tr2_td3": "300,000 ~",
    "flower_table_tr3_td1": "Luxury",
    "flower_table_tr3_td2": "500,000 ~",
    "flower_table_tr4_td1": "Premium",
    "flower_table_tr4_td2": "700,000 ~",
    "flower_table_desc": "※ P-Leisure 메인프로그램 이용 시 적용되는 특별가 입니다.",
    "flower_combi_title": "결합 가능한 P-Leisure 메인 프로그램",
    "flower_combi_desc1": "프라이빗 럭셔리요트",
    "flower_combi_desc2": "챌린저 골프",
    "flower_combi_desc3": "노블승마",
    "flower_combi_desc4": "제주어부",
    "flower_combi_desc5": "해피투게더",
    "flower_combi_desc6": "제주 숲토리텔링 투어",
    "flower_reserve_title": "예약문의 및 상담",
    "flower_reserve_desc1": "064-793-7070, 010-5328-7050, pinxleisure@sk.com",
    "flower_reserve_desc2": "월~금(공휴일 제외) 09:00 ~ 17:30 (점심시간 12:00 ~ 13:00)"
  },
  "en": {
    "breadcrumb": "Option Program",
    "flower_title": "Flower Service",
    "flower_subtitle": "Flower decorating service for precious people on a special day.",
    "prev_button": "Previous",
    "flower_desc": "Flower decorating service makes your special day more shining. Prepare a great gift for your loved ones with customized service on your special event including proposal or anniversary.",
    "flower_program_title": "Program",
    "flower_table_tr1_td1": "Program",
    "flower_table_tr1_td2": "Option",
    "flower_table_tr1_td3": "Fare*(2 people)",
    "flower_table_tr2_td1": "Flower decoration service",
    "flower_table_tr2_td2": "Inclusive",
    "flower_table_tr2_td3": "KRW 300,000 ~",
    "flower_table_tr3_td1": "Luxury",
    "flower_table_tr3_td2": "KRW 500,000 ~",
    "flower_table_tr4_td1": "Premium",
    "flower_table_tr4_td2": "KRW 700,000 ~",
    "flower_table_desc": "※ Special price for P-Leisure users",
    "flower_combi_title": "Combinable programs",
    "flower_combi_desc1": "private luxury yacht",
    "flower_combi_desc2": "challenger golf",
    "flower_combi_desc3": "noble riding",
    "flower_combi_desc4": "Jeju fisherman",
    "flower_combi_desc5": "Happytogether",
    "flower_combi_desc6": "Jeju forest-ory tour",
    "flower_reserve_title": "Reservation",
    "flower_reserve_desc1": "064-793-7070, 010-5328-7050, pinxleisure@sk.com",
    "flower_reserve_desc2": "MON~Sun (Excluding public holidays) 09:00 ~17:30 (Lunch 12:00 ~13:00)"
  },
  "ja": {
    "breadcrumb": "옵션 프로그램",
    "flower_title": "플라워 세팅",
    "flower_subtitle": "특별한 날, 소중한 분을 위한 플라워 데코레이팅 서비스",
    "prev_button": "이전",
    "flower_desc": "특별한 날을 더욱 빛나게 해 드릴 플라워 데코레이팅 서비스입니다.<br/>원하시는 이벤트에 따른 맞춤형 서비스로 프러포즈, 기념일 등 소중한 분을 위한 멋진 선물을 준비해 보세요.",
    "flower_program_title": "운영 프로그램",
    "flower_table_tr1_td1": "프로그램",
    "flower_table_tr1_td2": "옵션",
    "flower_table_tr1_td3": "요금(2인 기준)",
    "flower_table_tr2_td1": "플라워 데코레이팅 서비스",
    "flower_table_tr2_td2": "Inclusive",
    "flower_table_tr2_td3": "300,000 ~",
    "flower_table_tr3_td1": "Luxury",
    "flower_table_tr3_td2": "500,000 ~",
    "flower_table_tr4_td1": "Premium",
    "flower_table_tr4_td2": "700,000 ~",
    "flower_table_desc": "※ P-Leisure 메인프로그램 이용 시 적용되는 특별가 입니다.",
    "flower_combi_title": "결합 가능한 P-Leisure 메인 프로그램",
    "flower_combi_desc1": "프라이빗 럭셔리요트",
    "flower_combi_desc2": "챌린저 골프",
    "flower_combi_desc3": "노블승마",
    "flower_combi_desc4": "제주어부",
    "flower_combi_desc5": "해피투게더",
    "flower_combi_desc6": "제주 숲토리텔링 투어",
    "flower_reserve_title": "예약문의 및 상담",
    "flower_reserve_desc1": "064-793-7070, 010-5328-7050, pinxleisure@sk.com",
    "flower_reserve_desc2": "월~금(공휴일 제외) 09:00 ~ 17:30 (점심시간 12:00 ~ 13:00)"
  }
}
</i18n>
